import request from "axios";
import { PROJECT_ENTRIES_RESOURCE_NAME } from "admin/constants";
import { getAPIQueryString } from "common/utils";
import { savePageCount } from "common/pager/ducks";

/* ACTIONS
================================================================================================ */
const FETCH_ALL = "admin/FETCH_PROJECT_ENTRIES";
const FETCH_ALL_REQUEST = "admin/FETCH_PROJECT_ENTRIES_REQUEST";
const FETCH_ALL_SUCCESS = "admin/FETCH_PROJECT_ENTRIES_SUCCESS";

const CLEAR_ALL = "admin/CLEAR_PROJECT_ENTRIES";

const SET_VIEW_TYPE = "admin/SET_VIEW_TYPE";

const SET_GROUPING = "admin/SET_GROUPING";

const WITHDRAW = "admin/WITHDRAW_PROJECT_ENTRIES";
export const WITHDRAW_SUCCESS = "admin/WITHDRAW_PROJECT_ENTRIES_SUCCESS";

const UNWITHDRAW = "admin/UNWITHDRAW_PROJECT_ENTRIES";
export const UNWITHDRAW_SUCCESS = "admin/UNWITHDRAW_PROJECT_ENTRIES_SUCCESS";

const REMOVE_CREATIVE = "admin/REMOVE_CREATIVE";
export const REMOVE_CREATIVE_SUCCESS = "admin/REMOVE_CREATIVE_SUCCESS";

const HIDE = "admin/HIDE_PROJECT_ENTRY";
export const HIDE_SUCCESS = "admin/HIDE_PROJECT_ENTRY_SUCCESS";

const UNHIDE = "admin/UNHIDE_PROJECT_ENTRY";
export const UNHIDE_SUCCESS = "admin/UNHIDE_PROJECT_ENTRY_SUCCESS";

/* HELPERS
================================================================================================ */
export const getEntries = (state) => {
  const { list, grouped } = state.admin.projectEntries;
  if (grouped) {
    return list;
  }
  /* if not grouped, return an entry copy for each revision */
  return list.reduce((acc, entry) => {
    entry.revisions.forEach(
      (rev) => (acc = acc.concat({ ...entry, revisions: [rev] }))
    );
    return acc;
  }, []);
};

/* INITIAL STATES
================================================================================================ */
export const initialState = {
  list: [],
  isFetching: false,
  grouped: false,
};

/* REDUCERS
================================================================================================ */
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_ALL_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case FETCH_ALL_SUCCESS:
      return {
        ...state,
        list: action.payload.results,
        isFetching: false,
      };
    case CLEAR_ALL:
      return {
        ...state,
        list: [],
      };
    case SET_VIEW_TYPE:
      return {
        ...state,
        viewType: action.payload,
      };
    case SET_GROUPING:
      return {
        ...state,
        grouped: action.payload,
      };
    case WITHDRAW_SUCCESS:
    case REMOVE_CREATIVE_SUCCESS:
      return {
        ...state,
        list: state.list.map((entry) =>
          action.payload.includes(entry.id)
            ? { ...entry, withdrawn: true, withdrawn_by_admin: true }
            : entry
        ),
      };
    case UNWITHDRAW_SUCCESS:
      return {
        ...state,
        list: state.list.map((entry) =>
          action.payload.includes(entry.id)
            ? { ...entry, withdrawn: false, withdrawn_by_admin: false }
            : entry
        ),
      };
    case HIDE_SUCCESS:
      return {
        ...state,
        list: state.list.map((entry) =>
          action.id === entry.id ? { ...entry, hidden: true } : entry
        ),
      };
    case UNHIDE_SUCCESS:
      return {
        ...state,
        list: state.list.map((entry) =>
          action.id === entry.id ? { ...entry, hidden: false } : entry
        ),
      };
    default:
      return state;
  }
}

export const fetchAll = (projectId, query) => (dispatch) => {
  const queryStr = getAPIQueryString(PROJECT_ENTRIES_RESOURCE_NAME, query);
  const promise = request.get(
    `/api/v1/projects/${projectId}/entries/?${queryStr}`
  );

  /* save page count in pager state */
  promise.then((res) =>
    dispatch(savePageCount(PROJECT_ENTRIES_RESOURCE_NAME, res))
  );

  return dispatch({
    type: FETCH_ALL,
    promise,
  });
};

export const clearAll = () => {
  return {
    type: CLEAR_ALL,
  };
};

export const setViewType = (type) => {
  return {
    type: SET_VIEW_TYPE,
    payload: type,
  };
};

export const setGrouping = (grouped) => {
  return {
    type: SET_GROUPING,
    payload: grouped,
  };
};

export const withdraw = (creativeId, data) => (dispatch) => {
  return dispatch({
    type: WITHDRAW,
    promise: request.put(
      `/api/v1/radmin/users/${creativeId}/withdraw_entries/`,
      data
    ),
  });
};

export const unwithdraw = (creativeId, data) => (dispatch) => {
  return dispatch({
    type: UNWITHDRAW,
    promise: request.put(
      `/api/v1/radmin/users/${creativeId}/unwithdraw_entries/`,
      data
    ),
  });
};

export const removeCreative = (creativeId, data) => (dispatch) => {
  return dispatch({
    type: REMOVE_CREATIVE,
    promise: request.put(
      `/api/v1/radmin/users/${creativeId}/remove_creative/`,
      data
    ),
  });
};

export const hide = (creativeId, data) => (dispatch) => {
  return dispatch({
    type: HIDE,
    promise: request.put(
      `/api/v1/radmin/users/${creativeId}/hide_entry/`,
      data
    ),
    id: data.entry,
  });
};

export const unhide = (creativeId, data) => (dispatch) => {
  return dispatch({
    type: UNHIDE,
    promise: request.put(
      `/api/v1/radmin/users/${creativeId}/unhide_entry/`,
      data
    ),
    id: data.entry,
  });
};
